export default __webpack_public_path__ + "static/media/default-image.25a15a97.webp";